import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_public/coaches/ctp/$slug")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/training-programs/$slug",
      params: { slug: params.slug },
      statusCode: 301,
      throw: true,
    });
  },
  component: () => null,
});
